import { render } from "./PackagePanel.vue?vue&type=template&id=53c119fb"
import script from "./PackagePanel.vue?vue&type=script&lang=js"
export * from "./PackagePanel.vue?vue&type=script&lang=js"

import "./PackagePanel.vue?vue&type=style&index=0&id=53c119fb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__